import { Action } from '@ngrx/store';
import { PayloadAction } from '../types/payload-action';
import { GamificationProfileDto } from '../types/GamificationProfileDto';
import { GamificationLeaderboardDto } from '../types/GamificationLeaderboardDto';
import { GamificationActivityType } from '../types/gamification-activity-type';
import { GamificationBadgeDto } from '../types/GamificationBadgeDto';

export const GET_GAMIFICATION_PROFILE =
  '[Gamification] Get gamification profile';
export const STORE_GAMIFICATION_PROFILE =
  '[Gamification] Store gamification profile';
export const GET_GAMIFICATION_LEADERBOARD =
  '[Gamification] Get gamification leaderboard';
export const STORE_GAMIFICATION_LEADERBOARD =
  '[Gamification] Store gamification leaderboard';
export const GET_GAMIFICATION_BADGES = '[Gamification] Get gamification badges';
export const STORE_GAMIFICATION_BADGES =
  '[Gamification] Store gamification badges';

export function getGamificationProfileAction(): Action {
  return {
    type: GET_GAMIFICATION_PROFILE,
  };
}

export function storeGamificationProfileAction(
  data: GamificationProfileDto
): PayloadAction<GamificationProfileDto> {
  return {
    type: STORE_GAMIFICATION_PROFILE,
    payload: data,
  };
}

export function getGamificationLeaderboardAction(
  contactId: string
): PayloadAction<string> {
  return {
    type: GET_GAMIFICATION_LEADERBOARD,
    payload: contactId,
  };
}

export function storeGamificationLeaderboardAction(
  data: GamificationLeaderboardDto
): PayloadAction<GamificationLeaderboardDto> {
  return {
    type: STORE_GAMIFICATION_LEADERBOARD,
    payload: data,
  };
}

export function getGamificationBadgesAction(
  activityType: GamificationActivityType,
  forDate?: string
): PayloadAction<{
  activityType: GamificationActivityType;
  forDate?: string;
}> {
  return {
    type: GET_GAMIFICATION_BADGES,
    payload: {
      activityType,
      forDate,
    },
  };
}

export function storeGamificationBadgesAction(
  data: GamificationBadgeDto[]
): PayloadAction<GamificationBadgeDto[]> {
  return {
    type: STORE_GAMIFICATION_BADGES,
    payload: data,
  };
}



// WEBPACK FOOTER //
// ./ts/app/shared/actions/gamification.actions.ts